import React from "react";

const Dot = ({ res, testid }) => (
  <span
    data-testid={testid}
    className={`w-4 h-4 sm:w-5 sm:h-5 rounded-full border flex-shrink-0 ${
      res === "goal" ? "bg-[#10B981] border-[#10B981]" : res ? "bg-[#EF4444] border-[#EF4444]" : "bg-white/5 border-white/25"
    }`}
  />
);

const Squad = ({ p, testid }) =>
  p.taker && p.keeper ? (
    <div data-testid={`${testid}-squad`} className="flex gap-3 text-[11px] text-slate-400 min-w-0">
      <span className="truncate"><span className="font-bold text-slate-500">ST</span> {p.taker.name} <span className="text-slate-300 tabular-nums">{p.taker.rating}</span></span>
      <span className="truncate"><span className="font-bold text-slate-500">GK</span> {p.keeper.name} <span className="text-slate-300 tabular-nums">{p.keeper.rating}</span></span>
    </div>
  ) : null;

const Row = ({ name, score, results, testid, me, p }) => (
  <div className="space-y-1">
  <div className="flex items-center gap-2 sm:gap-3">
    <span className={`w-20 sm:w-28 truncate text-sm font-semibold ${me ? "text-[#10B981]" : "text-white"}`}>{name}</span>
    <div className="flex gap-1 sm:gap-1.5 flex-1 overflow-hidden">
      {Array.from({ length: Math.max(5, results.length) }).map((_, i) => (
        <Dot key={i} res={results[i]} testid={`${testid}-dot-${i}`} />
      ))}
    </div>
    <span data-testid={`${testid}-score`} className="font-display font-extrabold text-2xl tabular-nums w-7 text-right">{score}</span>
  </div>
  <Squad p={p} testid={testid} />
  </div>
);

// Shootout scoreboard: kick-by-kick dots for both sides.
export const Scoreboard = ({ me, them, revealed }) => {
  const mine = revealed.map((r) => r[me.role].result);
  const theirs = revealed.map((r) => r[them.role].result);
  return (
    <div data-testid="shootout-scoreboard" className="rounded-2xl bg-[#1E293B] border border-white/10 px-4 py-3 space-y-2">
      <Row name={`${me.username} (you)`} score={mine.filter((r) => r === "goal").length} results={mine} testid="score-me" me p={me} />
      <Row name={them.username} score={theirs.filter((r) => r === "goal").length} results={theirs} testid="score-them" p={them} />
    </div>
  );
};

export default Scoreboard;
